import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { PersonalInfoComponent } from '../../components/personal-info/personal-info.component';
import { AuthService } from '../../../auth/services/auth.service';
import { UserService } from '../../service/user.service';
import { TeacherService } from '../../service/teacher.service';
import { AdminService } from '../../service/admin.service';
import { SubdomainService } from '../../../../core/services/subdomain.service';
import { SettingsComponent } from '../../components/settings/settings.component';
import {
  ProfileTabId,
  ProfileToolbarComponent,
} from '../../components/profile-toolbar/profile-toolbar.component';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';
import { SubscriptionsComponent } from '../../components/subscriptions/subscriptions.component';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    PersonalInfoComponent,
    SettingsComponent,
    SubscriptionsComponent,
    ProfileToolbarComponent,
    ParentButtonComponent,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  #authService = inject(AuthService);
  #userService = inject(UserService);
  #teacherService = inject(TeacherService);
  #adminService = inject(AdminService);
  #subdomain = inject(SubdomainService);
  #route = inject(ActivatedRoute);
  #router = inject(Router);

  selectedTab = signal<ProfileTabId>('general');

  readonly showSubscriptions = computed(() =>
    this.#subdomain.isFamilySubdomain() && this.#userService.paymentsEnabled(),
  );

  readonly user = computed(() => {
    if (this.#subdomain.isSchoolSubdomain()) {
      return this.#teacherService.teacher();
    }
    if (this.#subdomain.isAdminSubdomain()) {
      return this.#adminService.admin();
    }
    return this.#userService.user();
  });

  ngOnInit(): void {
    const segment = this.#route.snapshot.queryParamMap.get('segment');
    if (segment === 'subscriptions' && this.showSubscriptions()) {
      this.selectedTab.set('subscriptions');
      void this.#router.navigate([], {
        relativeTo: this.#route,
        queryParams: { segment: null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }
  }

  onTabChange(tab: ProfileTabId): void {
    if (tab === 'subscriptions' && !this.showSubscriptions()) {
      return;
    }
    this.selectedTab.set(tab);
  }

  logout(): void {
    this.#authService.logout();
  }
}
